export var ResponsiveImageFormat;
(function (ResponsiveImageFormat) {
    ResponsiveImageFormat["WEBP"] = "webp";
    ResponsiveImageFormat["JPEG"] = "jpg";
})(ResponsiveImageFormat || (ResponsiveImageFormat = {}));
